import { ActionButton, Callout, ColorPicker, IconButton, Label, TextField, TooltipHost } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import React from 'react';

interface ICompactColorPickerProps {
    label?: string;
    showColorInControl?: boolean;
    placeholder?: string;
    color: string;
    onChange: (color: string) => void;
}

const CompactColorPicker: React.FC<ICompactColorPickerProps> = (props) => {
    const [isCalloutVisible, setIsCalloutVisible] = React.useState(false);
    // The value the field held when the callout was opened — "Revert" restores it, undoing
    // everything picked during this open (including the #000000 an empty field jumps to).
    const openColorRef = React.useRef<string>('');
    const fieldId = useId('field');

    const openCallout = () => {
        if (!isCalloutVisible) openColorRef.current = props.color;
        setIsCalloutVisible(!isCalloutVisible);
    };

    return (
        <>
            <Label>{props.label}</Label>
            <div style={{display: 'flex', alignItems: 'center'}}>
                <div style={{backgroundColor: props.color, width: '35px', height: '35px', paddingRight: '5px', border: '1px solid #ccc', boxSizing: 'border-box'}}></div>
                <TextField id={fieldId} value={props.color} readOnly onClick={openCallout} placeholder={props.placeholder} />
                {/* Always rendered (hidden when empty) so the row width never shifts when a color is set/cleared. */}
                <TooltipHost content={props.color ? 'Clear color (use default)' : undefined}>
                    <IconButton
                        iconProps={{ iconName: 'Cancel' }}
                        ariaLabel='Clear color'
                        onClick={() => props.onChange('')}
                        styles={{ root: { visibility: props.color ? 'visible' : 'hidden' } }}
                    />
                </TooltipHost>
            </div>
            {isCalloutVisible && (
                <Callout
                    target={`#${fieldId}`}
                    onDismiss={() => setIsCalloutVisible(false)}
                    setInitialFocus
                >
                    <ColorPicker
                        color={props.color}
                        onChange={(e, color) => {
                            props.onChange(color.str);
                        }}
                        alphaType='none'
                        />
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 0.5em 0.5em' }}>
                        <ActionButton
                            iconProps={{ iconName: 'Undo' }}
                            text='Revert'
                            disabled={props.color === openColorRef.current}
                            onClick={() => props.onChange(openColorRef.current)}
                        />
                        <ActionButton
                            iconProps={{ iconName: 'Cancel' }}
                            text='Clear'
                            disabled={!props.color}
                            onClick={() => {
                                props.onChange('');
                                setIsCalloutVisible(false);
                            }}
                        />
                    </div>
                </Callout>
            )}
        </>
    );
}

export default CompactColorPicker;
